import { PaginatedListSchema } from '../shared/paginatedList';
import { createPageListQueryValidationSchema } from '../page/list';
import { CheckoutPageMcpPayloadSchema, CheckoutPageToolDataValidationSchema } from './response';

export const CheckoutPageListQueryValidationSchema = createPageListQueryValidationSchema(
  "Case-insensitive contains match against the page's internal name, title and product title. Searching 'course' matches a page named 'Premium course' and a page whose product is titled 'Video course'. There is no filter by product type, price or slug: page through and inspect those fields instead.",
);

export const GetCheckoutPagesResponseValidationSchema = PaginatedListSchema(
  CheckoutPageMcpPayloadSchema,
);

export const CheckoutPagesToolResponseValidationSchema = PaginatedListSchema(
  CheckoutPageToolDataValidationSchema,
);
